import COMPONENT_MAP from '../Repository/Components.js';

const ErrorLogDetailPopup=({popupCallBack,rowId,userData,application})=>{
    const pageCallback=async(action,args)=>{
        if(action==='refreshParent'){
            popupCallBack(false);
        }
    }

    const renderPageDetail=()=>{
        const Component=COMPONENT_MAP['PageDetail'];
        return Component?(
            <Component
                recordId={rowId}
                userData={userData}
                application={application}
                entityType={'ErrorLog'}
                entityParams={['_lang=' + application.globalData.lang]}
                file={'ErrorLogDetailPopup.js'}
                titleLabel={application.getLocale("ErrorLogTitle")}
                pageCallback={pageCallback}
                pageTabs={[]}
                isPopUp={true}
                openOnUpdate={false}
            />
        ):null;
    };
    return (renderPageDetail());
}

export default ErrorLogDetailPopup;
